module.exports = __webpack_public_path__ + "img/ramhee_smart@2x.e244d38d.png";